<template>
  <div class="tw-flex tw-items-stretch">
    <div class="tw-grow tw-min-w-0 tw-flex tw-flex-col tw-gap-2">
      <div
        class="tw-grow tw-relative tw-flex tw-flex-row tw-items-start tw-gap-2"
      >
        <slot name="top-left"></slot>
        <div class="tw-grow tw-space-y-1 tw-overflow-hidden tw-min-h-6">
          <slot name="heading"></slot>
        </div>
        <div class="tw-whitespace-nowrap">
          <slot name="actions"></slot>
        </div>
      </div>
      <div
        class="tw-grow tw-relative tw-flex tw-flex-col tw-gap-2 empty:tw-hidden"
      >
        <slot name="before-message" />
      </div>
      <div
        class="tw-grow tw-relative tw-flex tw-flex-col tw-gap-2"
        :class="opacityClass"
      >
        <div
          v-if="!read"
          class="
            tw-absolute tw-start-[-8px] tw-inset-y-0 tw-w-0.5 tw-bg-sf-danger
          "
          data-testid="message-unread-indicator"
        />
        <slot name="body"></slot>
      </div>
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  hasOpacity?: boolean
  read?: boolean
}

const props = defineProps<Props>()

const opacityClass = computed(() => ({
  'tw-opacity-80': props.hasOpacity,
}))
</script>
